import { BUILD_ID } from "@/version";

export const CACHE_VERSION = `spore-${BUILD_ID}`;
let updatePending = false;
let registration = null;

export const hasPendingUpdate = () => updatePending;

if ("serviceWorker" in navigator) {
  const hadController = Boolean(navigator.serviceWorker.controller);
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (hadController) updatePending = true;
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((r) => { registration = r; }).catch(() => {});
  });
}

// True when the server has a newer build than the one running (or a new service worker took over).
export const checkForUpdate = async () => {
  try {
    registration?.update().catch(() => {});
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    const { build } = await r.json();
    if (build && build !== BUILD_ID) updatePending = true;
  } catch (e) {
    /* offline: keep running the current build */
  }
  return updatePending;
};

// Reload once per newer build (guards against reload loops if a stale bundle is still served).
export const reloadForUpdate = () => {
  const key = "spore_reloaded_from";
  if (sessionStorage.getItem(key) === BUILD_ID) return false;
  sessionStorage.setItem(key, BUILD_ID);
  window.location.reload();
  return true;
};

export const cacheReady = async () => {
  try {
    if (!("caches" in window)) return false;
    const c = await caches.open(CACHE_VERSION);
    return Boolean(await c.match("/sfx/initiating_braam.mp3"));
  } catch (e) {
    return false;
  }
};
